/**
 * Composable for interacting with Google Maps URLs.
 */
export const useMaps = () => {
    /**
     * Generates a Google Maps search URL from a query and optional context.
     * @param query The primary location or name (e.g., "Bordeaux" or "10 rue de la Paix")
     * @param context Optional context to refine the search (e.g., company name "Ubisoft")
     * @returns A string containing the Google Maps search URL
     */
    const getMapsUrl = (query: string, context?: string): string => {
        if (!query) return '';

        // Combine context and query if both are present
        // Example: context: "Ubisoft", query: "Bordeaux" -> "Ubisoft Bordeaux"
        const fullQuery = context ? `${context} ${query}` : query;

        const baseUrl = 'https://www.google.com/maps/search/?api=1';
        return `${baseUrl}&query=${encodeURIComponent(fullQuery)}`;
    }

    return {
        getMapsUrl
    }
}
